import React from 'react';
import * as PropTypes from 'prop-types';
import { makeBackendUrl } from '../../lib/backend';
import { resolveStrapiImage } from '../../lib/selectors';
import { classes, classNamer } from '../../lib/utils';

import './ProgressiveLoadingImage.scss';

const cn = classNamer('ProgressiveLoadingImage');

class ProgressiveLoadingImage extends React.PureComponent {
  static propTypes = {
    image: PropTypes.object,
    alt: PropTypes.string,
    className: PropTypes.string,
  };

  imageRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    if (this.imageRef.current.complete) {
      this.handleImageLoadCompleted();
    }
  }

  handleImageLoadCompleted = () => {
    this.setState({
      loaded: true,
    });
  };

  render() {
    /** @type {IStrapiImage} */
    const image = this.props.image;

    const fullImage = resolveStrapiImage(image, this.props.alt);
    const thumbnailUrl =
      image &&
      image.formats &&
      image.formats.thumbnail &&
      makeBackendUrl(image.formats.thumbnail.url);

    const fillerStyle =
      (fullImage.width &&
        fullImage.height && {
          paddingTop: (fullImage.height * 100) / fullImage.width + '%',
        }) ||
      undefined;

    return (
      <div
        className={classes(
          cn(),
          thumbnailUrl && cn('with-thumbnail'),
          this.state.loaded ? cn('loaded') : cn('loading'),
          !fillerStyle && cn('unknown-size'),
          this.props.className
        )}
      >
        <div className={cn('filler')} style={fillerStyle} />
        <img
          className={cn('full')}
          ref={this.imageRef}
          src={fullImage.url}
          alt={fullImage.alt}
          onLoad={this.handleImageLoadCompleted}
          onError={this.handleImageLoadCompleted}
        />
        {thumbnailUrl && <img className={cn('thumbnail')} src={thumbnailUrl} alt={fullImage.alt} />}
      </div>
    );
  }
}

export default ProgressiveLoadingImage;
